import { Utils } from 'cc-common';
import { Type } from 'class-transformer';
import { UserNameDisplayResultDto } from '../../_models/user-name-display-result-dto';

export class DocumentResultDto {
    fileId: number;
    fileName: string;
    fileUrl: string;
    size: number;
    description: string;

    @Type(() => Date)
    effectiveDate: Date;

    fileType: string;
    fileExists: boolean;

    allowEdit: boolean;
    allowRename: boolean;
    allowEmail: boolean;
    allowModifyOwner: boolean;
    allowDelete: boolean;
    allowAddToResalePackage: boolean;
    allowTrackCertified: boolean;
    category: string;
    subCategory: string;
    @Type(() => UserNameDisplayResultDto)
    uploadedBy: UserNameDisplayResultDto;
    @Type(() => Date)
    uploadedDate: Date;
    visibleOnResidentPortal: boolean;
    visibleOnBoardPortal: boolean;
    propertyAddress: string;
    printFlags: string;

    // Transient
    communityId: number;
    customerId: string;

    get uploadedByDisplayText(): string {
        return Utils.notNullAndDefined(this.uploadedBy) ? this.uploadedBy.displayName : '';
    }

    get sizeDisplayText(): string {
        let text = `${this.size}B`;
        if (this.size > 1024) {
            text = `${(this.size / 1024.0).toFixed(2)}KB`;
        }
        if (this.size > 1024 * 1024) {
            text = `${(this.size / (1024.0 * 1024.0)).toFixed(2)}MB`;
        }
        return text;
    }
}
